export { version as VERSION } from '@/../package.json'

declare const __GIT_SHA__: string
export const GIT_SHA: string = __GIT_SHA__
